'use strict';
 /**
 * @author Maxim Seredkin
 */
export default ['$scope', 'items', '$uibModalInstance',
    function ($scope, items, $modalInstance) {
        $scope.items = items;

        $scope.cancel = function () {
            $modalInstance.dismiss();
        };

        $scope.getSize = function (length) {
            if (length / 1000000000.0 > 1) {
                return length / 1000000000.0 + ' Гб';
            } else if (length / 1000000.0 > 1) {
                return length / 1000000.0 + ' Мб';
            } else if (length / 1000.0 > 1) {
                return length / 1000.0 + ' Кб';
            } else {
                return length / 1.0 + ' байт';
            }
        }
    }]